export default function checkZip(zip) {
  const normalizedZip = (zip || '').replace(/\s{2,}/g, ' ').trim();

  if (/^$|^\d{5}$|^\d{5}-\d{4}$|^[a-z0-9]{3}\s+[a-z0-9]{3}$/gi.test(normalizedZip)) return true;

  return false;
}
